import { useQuery as defaultUseQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { useCurrentAccountId } from '@zapier/payment/src/hooks/useCurrentAccountId';
import { currencyRulesetQuery as currencyRulesetQueryData } from './types/currencyRulesetQuery';
import { UseQuery } from '@zapier/payment/src/ts-types';

export const currencyRulesetQuery = gql`
  query currencyRulesetQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      currencyRuleset {
        currency
        method
        processor
        submethod
        submethodDisplay
      }
    }
  }
`;

type Input = {
  useQuery?: UseQuery;
};

export function useCurrencyRuleset(props: Input) {
  const { accountId } = useCurrentAccountId();
  const useQuery = props?.useQuery || defaultUseQuery;

  // @ts-ignore
  const { data, error, loading } = useQuery<currencyRulesetQueryData>(
    currencyRulesetQuery,
    {
      skip: !accountId,
      variables: { accountId },
    }
  );

  return {
    error: error ? 'There was an issue loading data.' : undefined,
    isLoading: loading,
    currencyRuleset: data?.account?.currencyRuleset ?? [],
  };
}
